<template>
  <div class="main">
    <c-panel>
      <form-distribuicao :paramId="$route.params.id" v-on:onSubmitDistribuicao="onSubmitDistribuicao"></form-distribuicao>
    </c-panel>
  </div>
</template>
<script>
import formDistribuicao from "./form"

export default {
  methods: {
    onSubmitDistribuicao () {
      this.$router.push('/admin/merenda/distribuicao')
    }
  },
  components: { formDistribuicao }
}
</script>

